module.exports = __webpack_public_path__ + "static/media/intro_7.38365d2f.png";